import { Component, OnInit, inject } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { fetchAuthSession } from 'aws-amplify/auth';
import { PosthogService } from '../../services/posthog.service';

@Component({
  selector: 'app-navbar',
  imports: [RouterLink, RouterLinkActive],
  templateUrl: './navbar.html',
})
export class NavbarComponent implements OnInit {
  private posthogService = inject(PosthogService);

  isAdmin = false;
  hasCRMAccess = false;
  hasTasksAccess = false;

  async ngOnInit() {
    try {
      const session = await fetchAuthSession();
      const groups = (session.tokens?.accessToken.payload['cognito:groups'] as string[]) || [];
      this.isAdmin = groups.includes('SUPERADMIN') || groups.includes('ADMIN');
    } catch (e) {
      this.isAdmin = false;
    }

    // Check feature flag access
    this.checkCRMAccess();
    this.checkTasksAccess();

    // Listen for feature flag updates
    this.posthogService.onFeatureFlags(() => {
      this.checkCRMAccess();
      this.checkTasksAccess();
    });
  }

  private checkCRMAccess(): void {
    this.hasCRMAccess = this.posthogService.featureFlagCRM();
  }

  private checkTasksAccess(): void {
    this.hasTasksAccess = this.posthogService.featureFlagTasks();
  }
}
